import { render } from "./CardNewsList.vue?vue&type=template&id=425c49a4&scoped=true"
import script from "./CardNewsList.vue?vue&type=script&lang=js"
export * from "./CardNewsList.vue?vue&type=script&lang=js"

import "./CardNewsList.vue?vue&type=style&index=0&id=425c49a4&scoped=true&lang=scss"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-425c49a4"]])

export default __exports__